"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

/**
 * Collapsible FAQ row for the feature pages. Matches the accordion in
 * ServicesSection. Lives apart from FeaturePageKit because it needs state,
 * and that kit has to stay server-side so pages can pass icon components in.
 */
export default function FaqItem({
    question,
    answer,
    purple,
}: {
    question: string;
    answer: string;
    purple?: boolean;
}) {
    const [open, setOpen] = useState(false);

    return (
        <div
            className="relative backdrop-blur-xs rounded-xl overflow-hidden transition-colors duration-200"
            style={
                purple
                    ? { background: "linear-gradient(135deg, #3b1160 0%, #1a0a2e 60%, #0d0d14 100%)" }
                    : { background: "#19131f79", border: "1px solid #7c44e511" }
            }
        >
            <button
                className="w-full flex items-center justify-between px-6 py-5 text-left gap-4"
                onClick={() => setOpen(!open)}
                aria-expanded={open}
            >
                <span className="text-white font-poppins font-medium text-sm sm:text-base">{question}</span>
                <ChevronDown
                    className="shrink-0 text-purple-400 transition-transform duration-300"
                    style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
                    size={20}
                />
            </button>
            <div className="overflow-hidden transition-all duration-300" style={{ maxHeight: open ? "320px" : "0px" }}>
                <p className="px-6 pb-5 text-gray-400 font-poppins text-sm leading-relaxed">{answer}</p>
            </div>
        </div>
    );
}
